@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.admin.pointofinterest

import com.narbase.letsgo.router.EndPoint

object UpdateElasticsearchSettingsEndpoint :
    EndPoint<UpdateElasticsearchSettingsEndpoint.Request, UpdateElasticsearchSettingsEndpoint.Response>() {
    class Request(
        val isActive: Boolean,
        val url: String,
    )

    class Response(
        val isActive: Boolean,
        val url: String,
    )
}
